<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="@/assets/logo_imfd.png" class="logo-imfd" />
      </b-navbar-item>
    </template>

    <template #start>
      <b-navbar-item>Paneles Covid-19</b-navbar-item>
    </template>

    <template #end>
      <b-navbar-item @click="onClickInfo">
        <b-icon icon="information-outline" size="is-medium" />
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import rootSchema from '@/schema'
import { Loading } from 'buefy'
import Vue from 'vue'

Vue.use(Loading)

export default {
  name: 'TheNavbar',
  data() {
    return {
      rootSchema
    }
  },
  methods: {
    async onClickInfo() {
      let shouldShowModal = true

      const loading = this.$buefy.loading.open({
        container: null,
        canCancel: true,
        onCancel: () => (shouldShowModal = false)
      })

      const AboutModal = await import('@/components/AboutModal')

      if (shouldShowModal) {
        loading.close()
        this.$buefy.modal.open({
          parent: this,
          component: AboutModal.default,
          trapFocus: true,
          hasModalCard: true
        })
      }
    }
  }
}
</script>

<style scoped>
.logo-imfd {
  max-height: 2.5rem;
}
</style>
